import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router-dom'
import update from 'react-addons-update'
import autobind from 'autobind-decorator'
import PendingTeacherBar from 'pobble-components/dist/pending-teacher-bar'
import { withMe } from 'pobble-components/dist/pobble-user'
import API from '../api'
import './Global.css'
import TopNavigation from '../../shared/TopNavigation.js'
import WorkEnvelope from './WorkEnvelope'
import Button from 'pobble-components/dist/button'

@autobind
class Search extends Component {
  constructor (props) {
    super(props)
    const limit = window.innerWidth > 800 ? 18 : 8
    this.state = {page: 0, limit, user: {}, works: []}
  }

  componentWillMount () {
    this.onSearch().then(works => {
        this.setState({ loading: false, works })
      })
    this.getUserInfos()
  }

  getUserInfos () {
    API.get('/v3/me?include=account.student_type,account.student_type.school').then(({data}) => this.setState({user: data.account}))
  }

  onSearch () {
    let { page, limit, user } = this.state
    this.setState({loading: true})
    return API.get(`/v3/search.json?&from=${page}&limit=${limit}`)
      .then(({data}) => {
        data.works.length && this.setState({loading: false, page: page + limit})
        return data.works
      })
  }

  render () {
    let workEnvelopes = this.state.works && this.state.works.slice(0,9).map((work, index) =>
      (work && work.id && <li key={index}>
        <Link to={{pathname: `/works/${work.id}`, state: this.state}}>
          <WorkEnvelope {...work} />
        </Link>
      </li>))

    let workEnvelopesReversed = this.state.works && this.state.works.reverse().slice(0,9).map((work, index) =>
      (work && work.id && <li key={index}>
        <Link to={{pathname: `/works/${work.id}`, state: this.state}}>
          <WorkEnvelope {...work} />
        </Link>
      </li>))

    return (
      <div>
        <PendingTeacherBar />
        <TopNavigation selected="global" />
        <header styleName='header'>
          <div styleName='header__wrapper wrapper'>
            <h1><strong>Celebrating writers</strong> around the world!</h1>
            <p>New to Pobble? <a href="https://www.pobble.com/publishing" target="_blank">How to get your pupils' work published here!</a></p>
            <img src="/images/search/hero-thumbs-up-girl.png" alt="Illustration" />
          </div>
        </header>
        <div styleName='envelopes'>
          <ul styleName='wrapper'>
            {workEnvelopes}
            <li styleName='cheers'><img src="/images/search/circle-boy-point.png" alt="Well done!" /></li>
          </ul>
        </div>
        <div styleName='stats'>
          <div styleName='wrapper'>
            <h2 styleName='stats__title'>Celebrating writers around the world!</h2>
            <img src="/images/search/stats-temp.jpg" alt="Celebrating" />
            <p styleName='stats__ctas'>
              <Button primary tall href="/actions/upload" styleName='stats__btn'>Publish your writers of the week now!</Button>
              <br/>
              <a href="https://www.pobble.com/publishing" target="_blank">New to Pobble? <strong>Find out how</strong></a>
            </p>
          </div>
        </div>
        <div styleName='envelopes'>
          <ul styleName='wrapper'>
            <li styleName='cheers'><img src="/images/search/circle-afro-boy.png" alt="Congratulations!" /></li>
            {workEnvelopesReversed}
          </ul>
        </div>
        <div styleName='visit'>
          <div styleName='wrapper'>
            <h2 styleName='visit__title'>Writing examples to support your teaching!</h2>
            <p>Did you know you can add writing exemplars to your Pobble lessons to share with your pupils.
            </p>
            <Button primary tall href="/lessons/works/all/all-ages" styleName='visit__btn'>Go to the Writing Bank</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default withMe(Search)



// WEBPACK FOOTER //
// ./components/search/Global.js